export default __webpack_public_path__ + "static/media/12.a0a5567a.jpeg";